import { render, staticRenderFns } from "./multiple_choice_selector_item.vue.js?vue&type=template&id=679e6046&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./multiple_choice_selector_item.vue?vue&type=template&id=679e6046&vue3"
import script from "./multiple_choice_selector_item.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./multiple_choice_selector_item.vue?vue&type=script&lang=js&vue3"
export * from "./multiple_choice_selector_item.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./multiple_choice_selector_item.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports